import React from 'react';
export const SignatureBookDetailModalButton = function EmptyComponent() { return null; };
